module.exports = __webpack_public_path__ + "img/ic-file.66b5aeba.svg";